export const zipcodeRex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
